import React from 'react';
const subStats = [{
  value: '6',
  label: 'Volumes + 5 Bonuses, Built for Beginners'
}, {
  value: '40+',
  label: 'Ready Sequences, No Prep Needed'
}, {
  value: '100%',
  label: 'Beginner-Focused, Start to Finish'
}];
export function BetterWay() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-37" data-mp="s6ffbdt8meqn">
      <div className="mx-auto max-w-4xl text-center" data-id="element-38" data-mp="wzqnpjdp73ko">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-terracotta sm:text-xs" data-id="element-39" data-mp="11ybqnqkc41ct">
          A Better Way to Teach Your First Classes
        </p>
        <h2 className="mx-auto mt-5 max-w-3xl text-2xl font-extrabold leading-tight tracking-tight text-teal sm:text-4xl" data-id="element-40" data-mp="16vbml8ngznq7">
          From an Overwhelmed New Teacher to a Confident Beginner-Class Instructor.
        </h2>
        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-41" data-mp="1fvgs1d93sc1q">
          You got certified to help people feel better in their bodies — not to spend every night
          before class guessing which sequence is safe, rehearsing what to say if your mind goes
          blank, or wondering if you're really ready. Walk in prepared, teach with confidence, and
          stop building every class from zero.
        </p>

        <dl className="mt-12 grid gap-5 sm:grid-cols-3" data-id="element-42" data-mp="3b9ex7czs6jh8">
          {subStats.map(stat => <div key={stat.label} className="rounded-3xl border border-sage/25 bg-cream-card px-6 py-8 text-center" data-id="element-43" data-mp="36abtbvvjejau">
              <dt className="sr-only" data-id="element-44" data-mp="2sk5mtofolig">{stat.label}</dt>
              <dd data-id="element-45" data-mp="2t21hp76oxpu">
                <span className="block text-3xl font-extrabold text-terracotta" data-id="element-46" data-mp="2qftjogdsg73">{stat.value}</span>
                <span className="mt-3 block text-sm font-medium leading-snug text-ink-soft" data-id="element-47" data-mp="3u0y2xrl6wbmy">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}